module.exports = __webpack_public_path__ + "static/media/omsin.b7b4451d.png";